import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {LocalizationService} from 'app/common/services/localization.service';
import {SharedModule} from 'app/shared/shared.module';
import {ICountry} from 'app/common/interfaces/ICountry';
import {Observable} from 'rxjs';
import {UntypedFormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';

@Component({
  selector: 'country-search-selector',
  standalone: true,
  imports: [
    SharedModule,
  ],
  templateUrl: './country-search-selector.component.html',
  styleUrl: './country-search-selector.component.scss',
})
export class CountrySearchSelectorComponent implements OnInit, OnChanges {
  @Input() readonly preselectedCountry: ICountry;

  @Output() countrySelected: EventEmitter<ICountry> = new EventEmitter();

  supportedCountries: ICountry[] = [];
  selectedCountry: ICountry;
  filteredCountries: Observable<ICountry[]>;
  searchFilterCtrl: UntypedFormControl = new UntypedFormControl();

  constructor(private localizationService: LocalizationService,
  ) {
  }

  ngOnInit(): void {
    this.supportedCountries = this.localizationService.getCountries();
    this.initSearchSubscription();
  }

  ngOnChanges(): void {
    if (this.preselectedCountry) {
      this.selectedCountry = this.preselectedCountry;
    }
  }

  selectCountry(country: ICountry): void {
    this.selectedCountry = country;
    this.countrySelected.emit(country);
  }

  private initSearchSubscription(): void {
    this.filteredCountries = this.searchFilterCtrl.valueChanges.pipe(
      startWith(''),
      map(search => this.filterCountries(search)),
    );
  }

  private filterCountries(search: string): ICountry[] {
    return this.supportedCountries.filter(country => country.name.toLowerCase().includes(search.toLowerCase()));
  }
}
